import { useHttpClientContext } from '@/shared/context/HttpClientContext';
import { useQueryErrorHandler } from '@/shared/hooks/useQueryErrorHandler';
import { PostPositionFulfillmentRequestSchema, PostPositionFulfillmentResponseSchema } from '@schuettflix/interfaces';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { z } from 'zod';

type PostPositionFulfillmentMutationFnArgs = {
    positionId: string;
    payload: z.input<typeof PostPositionFulfillmentRequestSchema>;
};

export const usePostPositionFulfillmentMutation = (
    hookOptions?: Pick<UseMutationOptions<any, any, PostPositionFulfillmentMutationFnArgs>, 'onSuccess'>
) => {
    const { handleMutationErrors } = useQueryErrorHandler();
    const { manualFulfillmentClient } = useHttpClientContext();

    return useMutation({
        ...handleMutationErrors,
        mutationFn: async ({ positionId, payload }: PostPositionFulfillmentMutationFnArgs) => {
            return await manualFulfillmentClient
                .post(`/v1/position/${positionId}/fulfillment`, payload)
                .then(({ data }) => PostPositionFulfillmentResponseSchema.parse(data));
        },
        ...hookOptions,
    });
};
